import { ButtonHTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

interface SwitchProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  isSelected: Boolean;
}

const Switch = ({ isSelected, disabled, ...props }: SwitchProps) => {
  return (
    <button
      className={twMerge(
        `flex cursor-pointer items-center transition-all duration-300 border-none p-[4px] w-10 h-6 bg-tertiary rounded-full ${
          isSelected ? "bg-primary" : ""
        } ${disabled ? "opacity-60" : ""}   `
      )}
      {...props}
    >
      <span
        className={`h-[15px] w-[15px] bg-white rounded-full transition-all ${
          isSelected ? "ml-3" : "hello"
        }`}
      ></span>
    </button>
  );
};

export default Switch;
